import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { HttpParams } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { Headers }  from '@angular/http';

@Injectable()
export class AutentificacionService {

 
  public url: string;
 
  constructor(public http: HttpClient){
      this.url = "https://apl.comandosoftware.com/integracion";

  }

  public getToken(idUser): Observable<any>{
      return this.http.post(this.url+"/prueba.php", {idUser: idUser,nombre:"william"} );
      //return this.http.post(this.url, {moo:"foo",nombre:"william"}  ,{ responseType: 'text' });
  }
  
  public validarUsuario(idUser:string, contra:string, token:string): Observable<any>{
       return this.http.post( this.url+"/verificarUsuario.php", {idUsuario: idUser , password: contra , token : token } );
       //return this.http.post(this.url, {moo:"foo",nombre:"william"}  ,{ responseType: 'text' });
   }

  public consultarHabitacionesDisponibles(idUser:string,  token:string, fechaInicio:string, fechaFin:string,documento:string , ip:string): Observable<any>{
    return this.http.post( this.url+"/consultarHabitaciones.php", {idUsuario: idUser , token : token, fechaInicio: fechaInicio, documento: documento, fechaFin:fechaFin, ip: ip } );
  }

  public getIp(): Observable<any>{
    return this.http.get("http://freegeoip.net/json/");
  }

  public obtenerCliente(idUser:string,  token:string, documento:string, ip:string): Observable<any>{
    return this.http.post(this.url+"/obtenerCliente.php", {documento: documento, idUsuario: idUser , token : token, ip: ip});
  } 

  public grabarCliente(idUsuario:string, token:string, ip:string, cliente:any ): Observable<any>{
    
    let documento = cliente.cedula;
    let nombre = cliente.nombre;
    let primerApellido = cliente.primerApellido;
    let segundoApellido =cliente.segundoApellido;
    let fechaNacimiento = cliente.fechaNacimiento;
    let direccion = cliente.direccion;
    let correo = cliente.correo;
    let ciudad = cliente.ciudad;

    return this.http.post(this.url+"/grabarCliente.php", {idUsuario: idUsuario , token : token, ip: ip, documento: documento, nombre: nombre, primerApellido: primerApellido, segundoApellido:segundoApellido,fechaNacimiento:fechaNacimiento, direccion: direccion, correo:correo, ciudad:ciudad } );
  }

  public grabarReserva(idUser:string,  token:string, documento:string, ip:string, fechaFin:string , fechaInicio:string, idHabitacion:number, adultos:number, idconvenio:any , idconvenioTarifa:any, valorTarifa:any): Observable<any>{
    return this.http.post(this.url+"/grabarReserva.php", {documento: documento, idUsuario: idUser , token : token, ip: ip, fechaInicio:fechaInicio , fechaFin:fechaFin, idHabitacion:idHabitacion, adultos:adultos, idconvenio:idconvenio, idconvenioTarifa:idconvenioTarifa, valorTarifa:valorTarifa});
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/autentificacion.service.ts